<template>
  <header
    class="sticky z-10 top-0 left-0 w-full bg-primary text-white p-4 overflow-x-hidden pl-8 pr-8"
  >
    <div class="flex justify-between items-center">
      <!-- Hamburger Button -->
      <button
        @click="mobileMenu = !mobileMenu"
        class="lg:hidden ml-2 focus:outline-none"
      >
        <PhList size="28" />
      </button>

      <!-- Logo and Nav -->
      <div class="flex gap-3 items-center">
        <router-link to="/" class="cursor-pointer header-text">
          <CompanyLogo
            v-if="!isMobile"
            width="150"
            height="45"
            class="text-white"
          />
          <CompanyLogo v-else width="150" height="50" class="text-white" />
        </router-link>
      </div>
      <div class="hidden lg:flex gap-3 items-center">
        <nav class="items-center" v-for="(item, i) in navItems" :key="i">
          <router-link
            :to="item.to"
            class="px-3 py-1 rounded-full font-medium text-base transition-all duration-200 hover:bg-[#B6B9C2] hover:text-[#0b1734]"
            v-if="item.title !== 'Apply Now'"
          >
            {{ item.title }}
          </router-link>
        </nav>
      </div>
      <!-- WhatsApp & Apply Button -->
      <div class="flex items-center lg:gap-4 gap-0">
        <a
          href="http://api.whatsapp.com/send?phone=27872650918&amp;text=Start"
          target="_blank"
          class="cursor-pointer"
        >
          <WhatsappLogo
            :width="isMobile ? 16 : 40"
            :height="isMobile ? 16 : 40"
          />
        </a>
        <router-link
          to="/apply-now"
          class="border border-black rounded-full bg-white text-center lg:px-4 lg:py-2 px-6 py-2.5 lg:w-[140px] w-[140px] transition-all duration-200 hidden lg:block font-rubik font-bold whitespace-nowrap text-[16px] lg:text-[16px] text-primary"
        >
          Apply Now
        </router-link>
      </div>
    </div>

    <!-- Slide-Out Mobile Menu -->
    <transition name="slide-right">
      <div
        v-if="mobileMenu"
        class="fixed inset-y-0 left-0 w-64 bg-white shadow p-6 flex flex-col gap-6"
      >
        <button @click="mobileMenu = false" class="self-end focus:outline-none">
          <PhX size="24" color="black" />
        </button>

        <router-link
          v-for="(item, i) in navItems"
          :key="i"
          :to="item.to"
          @click="mobileMenu = false"
          class="block px-3 py-2 rounded-full text-black font-medium text-base hover:bg-[#B6B9C2] hover:text-[#0b1734]"
        >
          {{ item.title }}
        </router-link>
        <!-- <a
          v-for="(item, i) in navItems"
          :key="i"
          :href="item.to"
          @click="mobileMenu = false"
          class="block px-3 py-2 rounded-full text-black font-medium text-base hover:bg-[#B6B9C2] hover:text-[#0b1734]"
        >
          {{ item.title }}
        </a> -->
      </div>
    </transition>
  </header>
</template>

<script setup>
import { defineProps, ref } from "vue";
import WhatsappLogo from "./Logos/SocialMedia/WhatsappLogo.vue";
import CompanyLogo from "./CompanyLogo.vue";
import { PhX, PhList } from "@phosphor-icons/vue";
defineProps({
  isMobile: {
    type: Boolean,
    default: false,
  },
});

const mobileMenu = ref(false);

const navItems = [
  { title: "Home", to: "/" },
  { title: "Marketplace", to: "/market-place" },
  { title: "How it Works?", to: "/#how_it_works" },
  { title: "About Us", to: "/about-us" },
  { title: "FAQ's", to: "/faqs" },
  { title: "Apply Now", to: "/apply-now" },
];
</script>

<style scoped>
.header-text {
  font-size: 2.3rem;
}

.bg-gradient {
  background: linear-gradient(160deg, #0b1734, #0b1734, #0b1734, #01186a);
}

/* .bg-gradient {
  background: linear-gradient(135deg, #0b1734, #0b1734, #0b1734, #0930bf);
} */
.slide-right-enter-active,
.slide-right-leave-active {
  transition: transform 0.3s ease-in-out;
}
.slide-right-enter-from {
  transform: translateX(-100%);
}
.slide-right-leave-to {
  transform: translateX(-100%);
}
</style>
